import assign = require('object-assign');
import {
    MAV,
    PM,
    SU
} from '../../constants';

import { IWidgetDataState } from '../../interfaces/states';

const initialState = {};

export function isResponsible(action) {
    switch (action.type) {
        case MAV.FETCH_SYSTEMS_REQUEST:
        case MAV.FETCH_SYSTEMS_SUCCESS:
        case MAV.FETCH_SYSTEMS_FAILURE:
        case MAV.FETCH_SYSTEMS_WITH_EVENTS_REQUEST:
        case MAV.FETCH_SYSTEMS_WITH_EVENTS_SUCCESS:
        case MAV.FETCH_SYSTEMS_WITH_EVENTS_FAILURE:
        case PM.FETCH_SYSTEMS_REQUEST:
        case PM.FETCH_SYSTEMS_SUCCESS:
        case PM.FETCH_SYSTEMS_FAILURE:
        case PM.FETCH_SYSTEMS_WITH_JOBS_REQUEST:
        case PM.FETCH_SYSTEMS_WITH_JOBS_SUCCESS:
        case PM.FETCH_SYSTEMS_WITH_JOBS_FAILURE:
        case PM.FETCH_SYSTEMS_WITH_SOFTWARE_REQUEST:
        case PM.FETCH_SYSTEMS_WITH_SOFTWARE_SUCCESS:
        case PM.FETCH_SYSTEMS_WITH_SOFTWARE_FAILURE:
        case SU.FETCH_SYSTEMS_REQUEST:
        case SU.FETCH_SYSTEMS_SUCCESS:
        case SU.FETCH_SYSTEMS_FAILURE:
        case SU.FETCH_PATCHES_REQUEST:
        case SU.FETCH_PATCHES_SUCCESS:
        case SU.FETCH_PATCHES_FAILURE:
        case SU.FETCH_JOBS_REQUEST:
        case SU.FETCH_JOBS_SUCCESS:
        case SU.FETCH_JOBS_FAILURE:
            return true;
        default:
            return false;
    }
}

function formatDate(system, key) {
    if (system[key]) {
        system[key] = new Date(system[key]);
    }
    return system;
}

function formatSystem(system) {
    if (system.pmInformation) {
        formatDate(system.pmInformation, 'LastScanTime');
        formatDate(system.pmInformation, 'SystemStartTime');
    }
    if (system.suInformation) {
        // formatDate(system.suInformation.lastJob, 'LastJobTime');
    }

    return system;
}

function formatSystems(systems) {
    if (Array.isArray(systems)) {
        systems.forEach(formatSystem);
        return systems;
    }

    Object.keys(systems).forEach(key => {
        systems[key].forEach(formatSystem);
    });

    return systems;
}

export default function systems(state = initialState, action): IWidgetDataState {
    switch (action.type) {
        case MAV.FETCH_SYSTEMS_WITH_EVENTS_REQUEST:
        case MAV.FETCH_SYSTEMS_REQUEST:
        case PM.FETCH_SYSTEMS_REQUEST:
        case PM.FETCH_SYSTEMS_WITH_JOBS_REQUEST:
        case PM.FETCH_SYSTEMS_WITH_SOFTWARE_REQUEST:
        case SU.FETCH_SYSTEMS_REQUEST:
        case SU.FETCH_PATCHES_REQUEST:
        case SU.FETCH_JOBS_REQUEST: {
            return assign({}, state, {
                systems: {
                    loading: true
                }
            });
        }
        case MAV.FETCH_SYSTEMS_WITH_EVENTS_SUCCESS:
        case PM.FETCH_SYSTEMS_WITH_JOBS_SUCCESS:
        case PM.FETCH_SYSTEMS_WITH_SOFTWARE_SUCCESS: {
            return assign({}, state, {
                systems: {
                    loading: false,
                    data: formatSystems(action.payload.systems)
                }
            });
        }
        case MAV.FETCH_SYSTEMS_SUCCESS:
        case PM.FETCH_SYSTEMS_SUCCESS:
        case SU.FETCH_SYSTEMS_SUCCESS:
        case SU.FETCH_PATCHES_SUCCESS:
        case SU.FETCH_JOBS_SUCCESS: {
            return assign({}, state, {
                systems: {
                    loading: false,
                    data: formatSystems(action.payload)
                }
            });
        }
        case MAV.FETCH_SYSTEMS_WITH_EVENTS_FAILURE:
        case MAV.FETCH_SYSTEMS_FAILURE:
        case PM.FETCH_SYSTEMS_FAILURE:
        case PM.FETCH_SYSTEMS_WITH_JOBS_FAILURE:
        case PM.FETCH_SYSTEMS_WITH_SOFTWARE_FAILURE:
        case SU.FETCH_SYSTEMS_FAILURE:
        case SU.FETCH_PATCHES_FAILURE:
        case SU.FETCH_JOBS_FAILURE: {
            return assign({}, state, {
                systems: {
                    loading: false,
                    error: action.error,
                    data: action.payload
                }
            });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/widgetData/systems.ts